import './values-section.css'
import { useTranslation } from 'react-i18next';

export default function ValuesSection(){
    const {t} = useTranslation();
    const values = [
        {
        icon: "fa-solid fa-handshake",
        title: "Commitment",
        description:
            "We are always committed to improving the quality that can bring success and satisfaction to your business.",
        },
        {
        icon: "fa-solid fa-universal-access",
        title: "Accessibility",
        description:
            "Always provide business-specific accessibility that can be used by people with various abilities and disabilities.",
        },
        {
        icon: "fa-solid fa-door-open",
        title: "Openness",
        description:
            "Openness will drive growth, innovation, collaboration, and strong relationships in personal and professional contexts.",
        },
    ];
    
    return(
        <div>
            <div className="values-section-details">
                <p className="main-heading">{t("Our Core Values")}</p>
                <h2 className="main-sub-heading">{t("The values that shape everything better")}</h2>
                <p className="main-description">
                    {t("Our team is a blend of technology enthusiasts and business development experts. From planning business strategies to delivering measurable results, our team wears many hats to serve our clients best.")}
                </p>
            </div>
            <div className="values-container">
                {values.map((value, index) => (
                    <div className="value-tile" key={index}>
                        <i className={value.icon}></i>
                        <h3>{t(value.title)}</h3>
                        <p>{t(value.description)}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}